import { Injectable } from '@angular/core';

import { FilterRefService } from '../services/filter-ref.service';
import { KpiService } from 'src/app/pages/dashboards/services/kpi.service';
import { MachineDataService } from 'src/app/pages/dashboards/services/machine-data.service';
import { SignalsService } from 'src/app/pages/dashboards/services/signals.service';

import { AppStateInterface } from 'src/app/appState.interface';
import { Store, select } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PostActions from './actions';
import {
  Observable,
  Subscription,
  catchError,
  distinctUntilChanged,
  forkJoin,
  map,
  mergeMap,
  of,
  switchMap,
  withLatestFrom
} from 'rxjs';
import {
  selectedCustomerUidSelector
} from './selectors';
import { isEqual } from 'lodash';
import { TableService } from 'src/app/pages/dashboards/services/table.service';

@Injectable()
export class PostEffects {

  getCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getCustomers),
      mergeMap(() => {
        return this.postService.getCustomers_20$().pipe(
          map((posts) => PostActions.getSuccesCustomers({ posts })),
          catchError((error) =>
            of(PostActions.getFailureCustomers({ error: error.message }))
          )
        );
      })
    )
  );

  getVehiclesOfCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getVehiclesOfCustomers),
      // switchMap (non mergeMap): la lista veicoli è pesante (~1MB / ~20s) ed è sempre relativa
      // al customer corrente. Se l'azione viene dispatchata più volte ravvicinate (es. bootstrap +
      // init filter-ref), annulliamo la richiesta in volo invece di scaricarla due volte in parallelo.
      switchMap(() => {
        let uidCustomer;
        let subselectedCustomerUidSelector: Subscription;
        subselectedCustomerUidSelector = this.store
          .pipe(select(selectedCustomerUidSelector))
          .subscribe((res) => {
            uidCustomer = res;
          });
        subselectedCustomerUidSelector.unsubscribe();

        // Controllo se uidCustomer è null o undefined
        if (!uidCustomer) {
          return of(PostActions.getFailureVehiclesOfCustomers({
            error: 'uidCustomer is null or undefined'
          }));
        }

        return this.postService.getVehiclesOfCustomers_20AllFilter$(uidCustomer).pipe(
          // tap(val =>{
          //   let defaultAssetType;
          //   let getTabAssetDefaultAssetTypeSub = this.store.pipe(select(getTabAssetDefaultAssetType)).subscribe((res) => {
          //       defaultAssetType = res;
          //   });
          //   getTabAssetDefaultAssetTypeSub.unsubscribe();
          //   if (defaultAssetType == 'VEHIC')
          //   {
          //   let appStoreList:SelectedAssets ={
          //     assetType: 'VEHIC',
          //     selected:  JSON.parse(JSON.stringify(val)),
          //     totSelected:val.length,
          //     isApply:false

          //   }
          //   //#FZ setto selectedAssetes (locale) e controllo se non ho settato ApllySeletectAssets (globale)
          //   // appStoreList.selected = JSON.parse(JSON.stringify(val));
          //   this.store.dispatch(PostActions.setSelectedAssets(appStoreList ));
          //   let subgetApplySelectedAssests:Subscription
          //   subgetApplySelectedAssests = this.store.pipe(select(getApplySelectedAssests)).subscribe((res) =>
          //   {
          //     if (res.selected.length == 0)
          //     {
          //       this.store.dispatch(PostActions.setApplySelectedAssets(appStoreList ));
          //     }
          //   }
          //   )
          //   subgetApplySelectedAssests.unsubscribe();
          // }

          // } ),
          map((posts) => PostActions.getSuccesVehiclesOfCustomers({ posts })),
          catchError((error) =>
            of(
              PostActions.getFailureVehiclesOfCustomers({
                error: error.message
              })
            )
          )
        );
      })
    )
  );

  getTrailersOfCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getTrailersOfCustomers),
      mergeMap(() => {
        let uidCustomer;
        let subselectedCustomerUidSelector: Subscription;
        subselectedCustomerUidSelector = this.store
          .pipe(select(selectedCustomerUidSelector))
          .subscribe((res) => {
            uidCustomer = res;
          });
        subselectedCustomerUidSelector.unsubscribe();

        // Controllo se uidCustomer è null o undefined
        if (!uidCustomer) {
          return of(PostActions.getFailureTrailersOfCustomers({
            error: 'uidCustomer is null or undefined'
          }));
        }

        return this.postService.getTrailersOfCustomers$(uidCustomer).pipe(
          map((posts) => PostActions.getSuccesTrailersOfCustomers({ posts })),
          catchError((error) =>
            of(
              PostActions.getFailureTrailersOfCustomers({
                error: error.message
              })
            )
          )
        );
      })
    )
  );

  getFleetsOfCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getFleetsOfCustomers),
      mergeMap(() => {
        let uidCustomer;
        let subselectedCustomerUidSelector: Subscription;
        subselectedCustomerUidSelector = this.store
          .pipe(select(selectedCustomerUidSelector))
          .subscribe((res) => {
            uidCustomer = res;
          });
        subselectedCustomerUidSelector.unsubscribe();

        // Controllo se uidCustomer è null o undefined
        if (!uidCustomer) {
          return of(PostActions.getFailureFleetsOfCustomers({
            error: 'uidCustomer is null or undefined'
          }));
        }

        return this.postService.getFleetsOfCustomers$(uidCustomer).pipe(
          map((posts) => PostActions.getSuccesFleetsOfCustomers({ posts })),
          catchError((error) =>
            of(
              PostActions.getFailureFleetsOfCustomers({
                error: error.message
              })
            )
          )
        );
      })
    )
  );

  getDriversOfCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getDriversOfCustomers),
      withLatestFrom(this.store.pipe(select(selectedCustomerUidSelector))),
      // switchMap: come per i veicoli, dispatch ravvicinati non devono generare chiamate parallele
      switchMap(([action, uidCustomer]) => {
        // Controllo se uidCustomer è null o undefined
        if (!uidCustomer) {
          return of(PostActions.getFailureDriversOfCustomers({
            error: 'uidCustomer is null or undefined'
          }));
        }

        return this.postService.getDriversOfCustomers_20$(uidCustomer).pipe(
          map((posts) => PostActions.getSuccesDriversOfCustomers({ posts })),
          catchError((error) =>
            of(
              PostActions.getFailureDriversOfCustomers({
                error: error.message
              })
            )
          )
        );
      })
    )
  );

  getTeamsOfCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getTeamsOfCustomers),
      mergeMap(() => {
        let uidCustomer;
        let subselectedCustomerUidSelector: Subscription;
        subselectedCustomerUidSelector = this.store
          .pipe(select(selectedCustomerUidSelector))
          .subscribe((res) => {
            uidCustomer = res;
          });
        subselectedCustomerUidSelector.unsubscribe();

        // Controllo se uidCustomer è null o undefined
        if (!uidCustomer) {
          return of(PostActions.getFailureTeamsOfCustomers({
            error: 'uidCustomer is null or undefined'
          }));
        }

        return this.postService.getTeamsOfCustomers$(uidCustomer).pipe(
          map((posts) => PostActions.getSuccesTeamsOfCustomers({ posts })),
          catchError((error) =>
            of(
              PostActions.getFailureTeamsOfCustomers({
                error: error.message
              })
            )
          )
        );
      })
    )
  );

  getSignalsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getSignalsTrendDataAction),
      /* distinctUntilChanged((prev, curr) =>{
        const equal = isEqual(prev.data, curr.data)
        if (equal) {
          this.store.dispatch(PostActions.unchangedData());
        }
        return equal;
      }), */
      switchMap((data) => {
        return this._signalsService.getSignalsTrendData(data.data).pipe(
          map((res) => {
            /* if (res.errorDescription) {
              return PostActions.getSignalsTrendDataFailure({
                error: res.errorDescription
              });
            } */
            const groupedData = this._signalsService.groupBySignal(res.data);
            return PostActions.getSignalsTrendDataSuccess({
              data: groupedData
            });
          }),
          catchError((error) =>
            of(PostActions.getSignalsTrendDataFailure({ error: error.message }))
          )
        );
      })
    )
  );

  getSignalsCatalog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getSignalsCatalogAction),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev.data.customerId) === JSON.stringify(curr.data.customerId)),
      switchMap((data) => {
        return forkJoin([
          this._signalsService.getCustomerSignalsConfigurationAvailable(data.data.uidUser, data.data.customerId),
          this._signalsService.getSignalsAvailable(data.data.customerId)
        ]).pipe(
          map(([configRes, signalsRes]) => {
            const configData = configRes && configRes.data && configRes.data[0] 
              ? { data: {commonAttributes: configRes.data[0].config.mappingData} } 
              : null;
            const signalsData = signalsRes && signalsRes.data 
              ? signalsRes.data : [];
            
            const configGrouped = configData ? this._signalsService.extractSignalsCatalog(configData.data) : {};
            const signalsGrouped = this._signalsService.extractSignalsCatalog(signalsData);
            const merged = this._signalsService.mergeConfigWithCatalogSignals(configGrouped, signalsGrouped);
            return PostActions.getSignalsCatalogSuccess({
              data: merged
            });
          }),
          catchError((error) =>
            of(PostActions.getSignalsCatalogFailure({ error: error.message }))
          )
        );
        /* return this._signalsService.getCustomerSignalsConfigurationAvailable(data.data.uidUser, data.data.customerId).pipe(
          switchMap((res) => {
            // If response is null, fall back to getSignalsAvailable
            if (!res || res.data[0] === null) {
              return this._signalsService.getSignalsAvailable(data.data.customerId);
            }
            // Otherwise, return the current response
            return of({ data: {commonAttributes: res.data[0].config.mappingData} });
          }),
          map((res) => {
            const groupedData = this._signalsService.extractSignalsCatalog(res.data);
            return PostActions.getSignalsCatalogSuccess({
              data: groupedData
            });
          }),
          catchError((error) =>
            of(PostActions.getSignalsCatalogFailure({ error: error.message }))
          )
        ); */
      })
    )
  );

  getKpiData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getKpiDataAction),
      switchMap((data) => {
        const standardKpi = (data.data.signals as { key: string, scope: string }[]).filter(s => !s.scope.includes('kpi_custom') && !s.scope.includes('composite_kpi'));
        const customKpi = (data.data.signals as { key: string, scope: string }[]).filter(s => s.scope.includes('kpi_custom'));
        const compositeKpi = (data.data.signals as { key: string, scope: string }[]).filter(s => s.scope.includes('composite_kpi'));

        let obs: Observable<any>[] = [
          standardKpi.length > 0 ? this.kpiService.getKpiData({
            ...data.data,
            signals: standardKpi.map(s => s.key)
          }) : of([]),
          customKpi.length > 0 ? this.kpiService.getKpiCustomData({
            ...data.data,
            signals: customKpi.map(s => s.key)
          }) : of([]),
          data.isVehicleStatsIncluded ? this.kpiService.getKpiVehicleStats({
            ...data.data,
            signals: compositeKpi.map(s => s.key)
          }) : of([])
        ];

        return forkJoin(obs).pipe(
          map((res) => {
            /* if (res.errorDescription) {
              return PostActions.getKpiDataFailure({
                error: res.errorDescription
              });
            } */
            if (data.isVehicleStatsIncluded) {
              this.store.dispatch(PostActions.getKpiVehicleStat({
                data: res[2].data ? res[2].data[0] : null
              }));
            }
            // Map data due to different custom kpi response 
            const customData = (res[1] || []).map((d: any) => {
              return {
                result_value: d.value,
                result_signal: d.signal,
                result_vin: d.vin,
              }
            });
            const d = [...(res[0].data || []), ...customData];
            return PostActions.getKpiDataSuccess({
              data: d
            });
          }),
          catchError((error) =>
            of(PostActions.getKpiDataFailure({ error: error.message }))
          )
        );
      })
    )
  );

  getMachineData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getMachineDataAction),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev.data[0]) === JSON.stringify(curr.data[0])),
      switchMap((data) => {
        return this.machineDataService.getMachineData(data.data).pipe(
          map((res) => {
            // Flatten all attributes from all scopes
            const flat: { [key: string]: string } = {};
            if (res.data && res.data.length > 0){
              for (const s of res.data[0].scopes) {
                for (const attr of s.attributes) {
                  flat[attr.name] = attr.value;
                }
              }
            }
            return PostActions.getMachineDataSuccess({
              data: flat
            });
          }),
          catchError((error) =>
            of(PostActions.getMachineDataFailure({ error: error.message }))
          )
        );
      })
    )
  );

  getCompositeSignalData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getCompositeSignalDataAction),
      switchMap((data) => {
        return this._signalsService.getCompositeSignalTrendData(data.data).pipe(
          map((res) => {
            /* if (res.errorDescription) {
              return PostActions.getCompositeSignalDataFailuer({
                error: res.errorDescription
              });
            } */
            if (!res.data) res.data = [];

            // Map the signals to their expected names
            for (const d of res.data) {
              for (const el of d.signals) {
                if (data.data.signals.some(name => name.includes(el.signal))) {
                  el.signal = (data.data.signals as string[]).find(name => name.includes(el.signal)) || el.signal;
                }
              }
            }
            const groupedData = this._signalsService.groupBySignal(res.data);
            return PostActions.getCompositeSignalDataSuccess({
              data: groupedData
            });
          }),
          catchError((error) =>
            of(PostActions.getCompositeSignalDataFailure({ error: error.message }))
          )
        );
      })
    )
  );

  getTableData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostActions.getTableDataAction),
      mergeMap((request) => {
        return this._tableService.getTableData(request.data).pipe(
          map((res) => {
            return PostActions.getTableDataSuccess({
              data: res.data,
              tableType: request.data.tableType
            });
          }),
          catchError((error) =>
            of(PostActions.getTableDataFailure({
              data: error.message,
              tableType: request.data.tableType
            }))
          )
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private postService: FilterRefService,
    private kpiService: KpiService,
    private machineDataService: MachineDataService,
    private _signalsService: SignalsService,
    private _tableService: TableService,
    private store: Store<AppStateInterface>
  ) {}
}
